import main from '@apply/pages/main';
export default [
  {
    path: '/apply',
    redirect: 'apply/index',
    component: main,
    children: [
      {
        path: 'index',
        name: 'apply/index',
        meta: { title: '首页', auth: true },
        component: () => import('@apply/pages/index.vue'),
      },
      {
        path: 'create',
        name: 'apply/create',
        meta: { title: '新建应用', auth: true },
        component: () => import('@apply/pages/create.vue'),
      },
      {
        path: 'update',
        name: 'apply/update',
        meta: { title: '修改应用', auth: true },
        component: () => import('@apply/pages/create.vue'),
      },
      {
        path: 'detail',
        name: 'apply/detail',
        meta: { title: '应用配置', auth: true },
        component: () => import('@apply/pages/detail.vue'),
      },
    ],
  },
];
